"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _select = _interopRequireDefault(require("../select"));
var _enum = require("../_util/enum");
var LargeSelect = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(LargeSelect, _Component);
  var _super = (0, _createSuper2["default"])(LargeSelect);
  function LargeSelect() {
    (0, _classCallCheck2["default"])(this, LargeSelect);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(LargeSelect, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_select["default"], (0, _extends2["default"])({
        size: _enum.Size.large
      }, this.props));
    }
  }]);
  return LargeSelect;
}(_react.Component);
exports["default"] = LargeSelect;
LargeSelect.Option = _select["default"].Option;